import axios from "axios";
import Globais, { validateToken } from "../../components/Globais";

export async function buscarTodosOsRepresentantesCotaUsuario(
  cotaUsuarioId: number | undefined | null
) {
  const Token = validateToken();

  if (Token) {
    //traz todos os representantes da cota validos e ainda a serem checados
    const URL = `${Globais.DOMINIOBACK}/representante/todos/cotausuario/${cotaUsuarioId}`;

    try {
      const response = await axios.get(URL, {
        headers: { Authorization: Token.AuthStr },
      });
      if (response) {
        if (response.data.length > 0) {
          return response.data;
        } else {
          return 0;
        }
      }
    } catch (e) {
      console.log(e);

      return false;
    }
  } else {
    document.location.href = "/login";
    return false;
  }
}
